export const ExternalLinkSlugs = {
    AnnotationsDocs: "argo-cd-annotations-docs",
    ArgoCDAuthenticationDocs: "argo-cd-authentication-docs",
    ArgoGatewayInstallationDocs: "argo-cd-octopus-gateway-installation-docs",
    ArgoCDDStepsDocs: "argo-cd-steps-docs",
    ArgoGatewayTroubleshootingDocs: "argo-cd-gateway-troubleshooting",
};
